import { render } from "./PriceMatrixComponent.vue?vue&type=template&id=41b7d3ca"
import script from "./PriceMatrixComponent.vue?vue&type=script&lang=js"
export * from "./PriceMatrixComponent.vue?vue&type=script&lang=js"

import "./PriceMatrixComponent.vue?vue&type=style&index=0&id=41b7d3ca&lang=css"

import exportComponent from "/buddy/vue-imprint-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__